// extracted by mini-css-extract-plugin
module.exports = {"heike":"heike-kabisch-module--heike--WPFlh","heikeImage":"heike-kabisch-module--heikeImage--KJqY2","background":"heike-kabisch-module--background--9p2Bx"};